import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { GrpcEchoRequest, GrpcEchoResultDto } from '../types/integrationHub';

/**
 * POST /api/eraf/integration-hub/grpc/echo — gRPC echo (unary/streaming) (INTEGRATION_INVOKE)
 * 성공 시 call-logs 캐시 무효화 (§Δ.1 append-only 재사용)
 */
export function useGrpcEcho() {
  const queryClient = useQueryClient();
  return useMutation<GrpcEchoResultDto, { code: string; message: string }, GrpcEchoRequest>({
    mutationFn: (req) => integrationHubApi.grpcEcho(req),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integration-hub', 'call-logs'] });
    },
  });
}
